module.exports = __webpack_public_path__ + "img/articleVaccination.3bc176b3.png";